import { useAppSelector } from 'src/app/store/hooks';
import { selectSendbirdAppId } from 'src/features/auth/selectors';
import { useUserRoles } from 'src/features/auth/useUserRoles';

export function useIsChatEnabled() {
  const sendbirdAppId = useAppSelector(selectSendbirdAppId);
  const { isAssociate, isRideOrderingPortalUser } = useUserRoles();

  return (
    process.env.REACT_APP_SENDBIRD_CHAT_ENABLED === 'true' &&
    sendbirdAppId &&
    !(isAssociate || isRideOrderingPortalUser)
  );
} 